import { useMemo } from 'react';
import { Menu, MenuButton, MenuList, MenuItem, Button, Icon, Box } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { MessageCircleQuestion, ChevronDown, X } from 'lucide-react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { SupportDomain } from '@duke-hq/svc-api/shared/tickets/ticketTags';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export function SupportTypeFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const filterLabel = useMemo(() => {
    if (filters.supportType === SupportDomain.GENERAL) {
      return t`General`;
    }

    if (filters.supportType === SupportDomain.ASSESSMENT) {
      return t`Assessment`;
    }

    if (filters.supportType === SupportDomain.LEARNING) {
      return t`Learning`;
    }

    if (filters.supportType === SupportDomain.CASELOAD) {
      return t`Caseload`;
    }

    return t`Support Type`;
  }, [filters.supportType]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<Icon as={MessageCircleQuestion} boxSize={4} />}
        rightIcon={
          filters.supportType !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ supportType: undefined });
              }}
              ml={1}
            >
              <X size={iconSize.md} />
            </Box>
          ) : (
            <ChevronDown size={iconSize.md} />
          )
        }
        variant="ghost"
        size="sm"
        fontWeight="normal"
        px={3}
      >
        {filterLabel}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => updateFilters({ supportType: SupportDomain.GENERAL })}>
          <Trans>General</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ supportType: SupportDomain.ASSESSMENT })}>
          <Trans>Assessment</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ supportType: SupportDomain.LEARNING })}>
          <Trans>Learning</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ supportType: SupportDomain.CASELOAD })}>
          <Trans>Caseload</Trans>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
